var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Button, Span, ToolTipButton, TooltipStyled } from './Components/Button';
import { GridComponent, TextComponent } from './Components/Grid';
import { GroupBox } from './Components/GroupBox';
import { LabelContainer } from './Components/LabelContainer';
import LabelValue from './Components/LabelValue';
import { MenuButtons } from './Components/MenuButtons';
import StateValue from './Components/StateValue';
import { Table } from './Components/Table';
import { Tabs } from './Components/Tabs';
import { BUTTON, DIV, DROPDOWN, GRID, GROUPBOX, INDICATOR_BUTTON, LABEL, LABEL_CONTAINER, LABEL_VALUE, SPAN, STATE_VALUE, TABLE, TABS, TOOL_TIP_BUTTON, TOOLTIP } from './componentTypes';
export function ComponentType(props) {
    var _a = props.component, component = _a === void 0 ? '' : _a, rest = __rest(props, ["component"]);
    switch (component.toLowerCase()) {
        case DROPDOWN:
            return React.createElement(MenuButtons, __assign({}, rest));
        case TABS:
            return React.createElement(Tabs, __assign({}, rest));
        case LABEL:
            return React.createElement(TextComponent, __assign({}, rest));
        case LABEL_VALUE:
            return React.createElement(LabelValue, __assign({}, rest));
        case STATE_VALUE:
            return React.createElement(StateValue, __assign({}, rest));
        case TOOLTIP:
            return React.createElement(TooltipStyled, __assign({}, rest));
        case SPAN:
            return React.createElement(Span, __assign({}, rest));
        case GROUPBOX:
            return React.createElement(GroupBox, __assign({}, rest));
        case TABLE:
            return React.createElement(Table, __assign({}, rest));
        case TOOL_TIP_BUTTON:
            return React.createElement(ToolTipButton, __assign({}, rest));
        case INDICATOR_BUTTON:
            return React.createElement(Button, __assign({}, rest, { isIndicator: true }));
        case BUTTON:
            return React.createElement(Button, __assign({}, rest));
        case LABEL_CONTAINER:
            return React.createElement(LabelContainer, __assign({}, rest));
        case GRID:
        case DIV:
        default:
            return React.createElement(GridComponent, __assign({}, rest));
    }
}
export function Component(props) {
    var component = props.component, _a = props.style, style = _a === void 0 ? {} : _a, restProps = __rest(props, ["component", "style"]);
    return (React.createElement(ComponentType, __assign({ "data-component": component, component: component, componentStyle: style }, restProps)));
}
//# sourceMappingURL=Component.js.map